<template>
    <div id="fsimg" class="fullscreen-img" v-show="fs.display" ref="overlay" @click="hideOverlay">
        <img ref="refImage" v-if="fs.display==true" :src="page.mediaCollection[fs.index].source_url" loading="lazy" :srcset="page.mediaCollection[fs.index].srcset" @mouseenter="showCaption" @mouseleave="hideCaption"/>
        <a class="info-button" @click.stop.prevent="toggleCaption"><FontAwesomeIcon icon="circle-info" size="sm"/></a>
        <a class="close-button" @click="hideOverlay"><FontAwesomeIcon icon="circle-xmark" size="sm"/></a>
        <a class="prev-button" v-show="fs.index>0" @click.stop.prevent="prevImg"><FontAwesomeIcon icon="chevron-left" size="4x"/></a>
        <a class="next-button" v-show="fs.index<page.mediaCollection.length-1" @click.stop.prevent="nextImg"><FontAwesomeIcon icon="chevron-right" size="4x"/></a>
        <div v-if="fs.caption!==null" class="caption">
            <p class="title">{{ caption }}</p>
        </div>
    </div>
</template>
<style lang="scss">
.fullscreen-img {
    position: absolute;
    z-index: 10;
    width: calc(100% - 1rem);
    height: 100%;
    //display: none;
    background: rgba(0,0,0,0.50);
    backdrop-filter: blur(6px);
    img{
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        margin: auto;
        position: absolute;
        top: 0; left: 0; bottom: 0; right: 0;
        box-shadow: 0 0 1rem 1rem black;
    }
    .caption {
        position: absolute;
        // top: calc(100vh - 3rem);
        bottom: 3rem;
        .title {
            background: var(--grissira);
            color: #fff;
        }
        font-weight: bold;
        text-transform: uppercase;
        height: 7rem;
        width: 100%;
        transition: 500ms;
        opacity: 0;
        display: block;
        padding: 1rem;
    }
    .title {
        //position: absolute;
        display: block;
        width: 100%;
        bottom: 0;
        padding: 0.5rem 0.5rem;
        white-space: normal;
        box-shadow: 0.2rem 0.2rem 0.5rem black;
    }
    .close-button {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        width: 32px;
        height: 32px;
        display: block;
        font-size: 2rem;
        transition: 500ms;
        color: #fff;
    }
    .info-button {
        position: absolute;
        top: 0.5rem;
        right: 3rem;
        width: 32px;
        height: 32px;
        display: block;
        font-size: 2rem;
        transition: 500ms;
        color: #fff;
    }
    .prev-button, .next-button {
        position: absolute;
        top: 50%;
        margin-top: -4rem;
        // width: 8rem;
        // height: 8rem;
        display: block;
        // font-size: 2rem;
        transition: 500ms;
        color: #fff;
        opacity: 0.5;
    }
    .prev-button {
        left: 1rem;
    }
    .next-button {
        right: 1rem;
    }
    @media only screen and (min-width: 1024px) {
        .title {
            max-width: 800px;
            margin: auto;
            padding: 1rem;
            transition: 500ms;
        }
        .prev-button, .next-button {
            opacity: 1;
        }
        .info-button {display: none;}
        .caption.displayed {
            opacity: 1;
        }
    }
}
// .fullscreen-img:hover .caption{
//     opacity: 1;
// }
@media only screen and (max-width: 1023.9px) {
    .fullscreen-img .caption.fixdisplayed{
        opacity: 1;
    }
}

</style>
<script setup>
import { ref, computed } from 'vue'
import { useSwipe } from '@vueuse/core'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronUp, faChevronLeft, faChevronRight, faCircleXmark, faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


library.add([faChevronUp,faChevronLeft,faChevronRight,faCircleXmark,faCircleInfo])

import { useFullScreen } from '@/stores/fullscreen_state'
import { usePage } from '@/stores/page_state'

// eslint-disable-next-line no-undef
const overlay = ref(null)
const fs = useFullScreen()
const page = usePage()

const caption = computed(() => {
    if(page.mediaCollection[fs.index]===undefined) return ""
    let el=document.createElement('div')
            el.innerHTML=page.mediaCollection[fs.index].caption.rendered
            return el.textContent
})

var swipeOffset = 0
fs.display=false
function hideOverlay() {
    fs.display=false
}

function hideOnEscape(e) {
    if (fs.display == true) {
        switch(e.key){
            case "Escape" :
                hideOverlay()
                //TODO maybe remove the "zoomed" class on #fsimg
                break
            case "ArrowLeft" :
                prevImg()
                break
            case "ArrowRight" :
                nextImg()
                break
        }
        e.preventDefault()
    }
}
// const zoomed = ref(false)

const refImage = ref(null)
const { direction, lengthX } = useSwipe(
    refImage, { // your ref element 
        onSwipe() {
            swipeOffset = lengthX.value
            if(direction.value==="LEFT"&&fs.index<page.mediaCollection.length-1||
            direction.value==="RIGHT"&&fs.index>0){
                refImage.value.style.left = -swipeOffset + 'px'
                refImage.value.style.right = swipeOffset + 'px'
            }
        },
        onSwipeEnd() {
            //console.log( 'final offset : ' + swipeOffset )
            if (swipeOffset > 40) nextImg()
            else if (swipeOffset < -40 ) prevImg()
            swipeOffset = 0
            refImage.value.style.left = swipeOffset
            refImage.value.style.right = swipeOffset
        }
    }
)

function nextImg() {
    if (fs.index < page.mediaCollection.length - 1) fs.index++
    console.log("nextImg",fs.index)
}

function prevImg() {
    if (fs.index > 0) fs.index--
    console.log("prevImg",fs.index)
}

function toggleCaption (){
    let img = document.getElementsByClassName("caption")[0]
    img.classList.toggle("fixdisplayed")
}
function showCaption (){
    let img = document.getElementsByClassName("caption")[0]
    img.classList.add("displayed")
}function hideCaption (){
    let img = document.getElementsByClassName("caption")[0]
    img.classList.remove("displayed")
}
document.body.addEventListener('keydown', hideOnEscape);
</script>